const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_BASE_URL = {
  LOGIN: `${BASE_URL}/auth`,
  SIGNUP: `${BASE_URL}/auth/signup`,
  CLIENTE: `${BASE_URL}/app_cliente`,
  CATEGORIA_ITEM: `${BASE_URL}/categoria_item`,
  CATMAT_ITEM: `${BASE_URL}/catmat_item`,
  CATMAT_CLASSE: `${BASE_URL}/catmat_classe`,
  CATMAT_GRUPO: `${BASE_URL}/catmat_grupo`,
  CATMAT_PDM: `${BASE_URL}/catmat_pdm`,
  CATSER_ITEM: `${BASE_URL}/catser_item`,
  CATSER_CLASSE: `${BASE_URL}/catser_classe`,
  CATSER_GRUPO: `${BASE_URL}/catser_grupo`,
  EFISCO_PE_ITEM: `${BASE_URL}/efisco_pe_item`,
  EFISCO_PE_CLASSE: `${BASE_URL}/efisco_pe_classe`,
  EFISCO_PE_GRUPO: `${BASE_URL}/efisco_pe_grupo`,
  DFD: `${BASE_URL}/dfd`,
  IMPORT_CATMAT: `${BASE_URL}/import_catmat`,
  IMPORT_CATSER: `${BASE_URL}/import_catser`,
  DFD_ITEM: `${BASE_URL}/dfd_item`,
  USUARIO: `${BASE_URL}/usuario`,
  USUARIO_BIND: `${BASE_URL}/usuario_bind`,
  REQUISITANTE: `${BASE_URL}/requisitante`,
  NATUREZA: `${BASE_URL}/natureza_despesa`,
  UF: `${BASE_URL}/uf`,
  MUNICIPIO: `${BASE_URL}/municipio`,
  UNIDADE_MEDIDA: `${BASE_URL}/unidade_medida`,
  UNIDADE_CATSER: `${BASE_URL}/unidade_catser`,
  TRAMITACAO: `${BASE_URL}/tramitacao`,
  APP_IMAGES: `${BASE_URL}/app_images`,
  PCA: `${BASE_URL}/pca`,
  DFD_LOTE: `${BASE_URL}/dfd_lote`,
  RELATORIO: `${BASE_URL}/relatorio`,
  TIPO_OBJETO: `${BASE_URL}/tipo_objeto`,
  CATMAT: `${BASE_URL}/catmat`,
  CATMAT_UM: `${BASE_URL}/catmat_um`,
  CATSER: `${BASE_URL}/catser`,
  CATSER_UM: `${BASE_URL}/catser_um`,
  TABSUS: `${BASE_URL}/tabsus`,
  EFISCO_PE: `${BASE_URL}/efisco-pe`,
  RESPONSABILIDADE: `${BASE_URL}/responsabilidade`,
  CNPJ_PROXY: `${BASE_URL}/cnpj`,
  APP_MARGINS: `${BASE_URL}/app_margins`,
  FORGOT_PASSWORD: `${BASE_URL}/auth/forgot-password`,
  RESET_PASSWORD: `${BASE_URL}/auth/reset-password`,
};

